import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#707070",
    viewBox: "0 0 81 81",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="40.398" cy="40.481" r="39.5" stroke="#243E81" stroke-width="2" fill="#EDF1F5"/> <path stroke="#243E81" stroke-width="2" d="M33.32 27.42a4.067 4.067 0 1 1-8.133 0 4.067 4.067 0 0 1 8.133 0zm22.279 0a4.067 4.067 0 1 1-8.134 0 4.067 4.067 0 0 1 8.134 0zM37.17 43.104v14.505H21.348V42.104a6.13 6.13 0 0 1 6.129-6.13h3.552a6.13 6.13 0 0 1 6.128 6.13v1zm22.279 0v14.505H43.626V42.104a6.13 6.13 0 0 1 6.13-6.13h3.551a6.13 6.13 0 0 1 6.128 6.13v1z"/>' }
  })
);